import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { Drawer } from "vaul";
import { DrawerPortal } from "@/components/Drawer";
import { Dialog, DialogContent } from "@/components/Dialog";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import { Then } from "@componentsShared/Conditional/Then";
import { Else } from "@componentsShared/Conditional/Else";
import { Icon } from "@syarahtech/ui";
import useIsMobile from "@hooks/useIsMobile";
var CANCEL_ICON_URL = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='96' height='82' viewBox='0 0 96 82' fill='none'%3E%3Cpath opacity='0.4' d='M96 33.3968V47.9778C96 72.2794 86.4 82 62.4 82H33.6C9.6 82 0 72.2794 0 47.9778V33.3968C0 12.9929 6.768 2.88732 23.136 0.144366H24L72 0C88.992 2.50234 96 12.6561 96 33.3968Z' fill='%23FAE1B2'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M19.9492 40.5C19.9492 24.7608 32.6777 12 48.377 12C64.0779 12 76.8048 24.7608 76.8048 40.5C76.8048 56.2428 64.0781 69 48.377 69C32.6777 69 19.9492 56.241 19.9492 40.5ZM25.2795 40.4999C25.2795 53.2892 35.6201 63.6561 48.377 63.6561C61.1339 63.6561 71.4745 53.2892 71.4745 40.4999C71.4745 27.7106 61.1339 17.3438 48.377 17.3438C35.6201 17.3438 25.2795 27.7106 25.2795 40.4999ZM48.3788 24.499C46.3428 24.499 44.8022 25.5643 44.8022 27.2849V43.0668C44.8022 44.7892 46.3426 45.8509 48.3788 45.8509C50.3652 45.8509 51.9555 44.7448 51.9555 43.0668V27.2849C51.9553 25.6051 50.3652 24.499 48.3788 24.499ZM44.8304 52.9651C44.8304 51.0023 46.4225 49.4062 48.3787 49.4062C50.3348 49.4062 51.9249 51.0021 51.9251 52.9651C51.9251 54.9244 50.3348 56.5205 48.3787 56.5205C46.4225 56.5205 44.8304 54.9244 44.8304 52.9651Z' fill='%23FCC094'/%3E%3C/svg%3E";
var AmwalCancelPopup = function AmwalCancelPopup(_ref) {
  var show = _ref.show,
    onClose = _ref.onClose,
    onConfirm = _ref.onConfirm,
    onCancel = _ref.onCancel;
  var _useTranslation = useTranslation(["web_tracking", "web_checkout_finance"]),
    t = _useTranslation.t;
  var isMobile = useIsMobile();
  var content = /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center"
  }, /*#__PURE__*/React.createElement("span", {
    className: "w-[72px] h-[72px] mb-6 rounded-xl bg-no-repeat bg-center",
    style: {
      backgroundImage: "url(\"".concat(CANCEL_ICON_URL, "\")")
    }
  }), /*#__PURE__*/React.createElement("strong", {
    className: "text-center text-[#154f9c] text-xl font-bold leading-8 mb-2"
  }, t("sure_cancel_application", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-center text-[#154f9c] text-base font-semibold leading-7 mb-6"
  }, t("information_saved_need_refill_data", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("button", {
    className: "blueBtn max-w-[318px] h-14 w-4/5 rounded cursor-pointer text-white text-base font-bold leading-6",
    onClick: onConfirm
  }, t("continue_application", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("button", {
    className: "whtBtn max-w-[318px] h-14 w-4/5 rounded cursor-pointer text-white text-base font-bold leading-6 mt-4",
    onClick: onCancel
  }, t("cancel_submitting_application", {
    ns: "web_tracking"
  })));
  return /*#__PURE__*/React.createElement(Conditional, {
    condition: isMobile
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement(Drawer.Root, {
    open: show,
    onOpenChange: function onOpenChange(open) {
      return !open && onClose();
    },
    onClose: onClose
  }, /*#__PURE__*/React.createElement(DrawerPortal, null, /*#__PURE__*/React.createElement(Drawer.Overlay, {
    className: "fixed inset-0 bg-[#071425] opacity-80 z-[9998]"
  }), /*#__PURE__*/React.createElement(Drawer.Content, {
    className: "bg-white flex flex-col rounded-t-[10px] fixed bottom-0 left-0 right-0 z-[9999] py-4 px-6"
  }, content)))), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement(Dialog, {
    open: show,
    onOpenChange: function onOpenChange(open) {
      return !open && onClose();
    }
  }, /*#__PURE__*/React.createElement(DialogContent, {
    className: "min-w-[570px] p-6",
    haveClose: false,
    overlayClassName: "z-[9999]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute en:left-[unset] left-4 en:right-4 top-4 rounded-sm focus:outline-none disabled:pointer-events-none bg-transparent border-none",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--close-small-outline-rounded",
    width: 6,
    height: 6,
    className: "text-[#4D4D4F] cursor-pointer"
  })), content))));
};
export default AmwalCancelPopup;